import { dom, mapActiveClass } from "../helpers/dom.js";

class FullBreadcrumbs {
  constructor({ onClick }) {
    this._onClick = onClick || (() => {});
  }
  init() {
    const dom = this._makeDom();
    dom.addEventListener("click", this._onClick);
    return dom;
  }
  _makeDom() {
    return dom("div.breadcrumbs", {}, [
      dom("a.breadcrumbs__back", {}, [dom("i.icon-back", {}, "")]),
      dom("a.breadcrumbs__top", { href: "#" }, "Назад"),
      dom("div.breadcrumbs__delimiter", {}, [dom("i.icon-right", {}, "")]),
      dom("a.breadcrumbs__second", { href: "#" }, "В каталог")
    ]);
  }
}

export default FullBreadcrumbs;



// WEBPACK FOOTER //
// ./src/js/components/fullBreadcrumbs.js